import React from 'react';
import { MapPinIcon, QuoteIcon, StarIcon } from 'lucide-react';
import { useLanguage } from '../hooks/useLanguage';
import { testimonials } from '../data/testimonials';
import { ui } from '../data/translations';
export function Testimonials() {
  const {
    t
  } = useLanguage();
  return <section id="testimonials" className="w-full bg-navy py-20 lg:py-28" data-id="element-223" data-mp="3b1471ipihv7y">
      <div className="mx-auto max-w-7xl px-5 lg:px-8" data-id="element-224" data-mp="3ayqbl8qx6gzv">
        <div className="max-w-2xl" data-id="element-225" data-mp="36zr178mf5s11">
          <h2 className="font-display text-3xl font-bold leading-tight text-white lg:text-4xl" data-id="element-226" data-mp="36wmofmuw1nyr">
            {t(ui.testimonials.title)}
          </h2>
          <p className="mt-4 text-white/70" data-id="element-227" data-mp="2x1urml94r551">{t(ui.testimonials.subtitle)}</p>
        </div>

        <ul className="mt-12 grid gap-6 md:grid-cols-2" data-id="element-228" data-mp="2s2i6q61tk853">
          {testimonials.map(item => <li key={item.author} data-id="element-229" data-mp="v9or9rdnlu65">
              <figure className="flex h-full flex-col rounded-lg border-l-4 border-gold bg-navy-soft p-7 sm:p-8" data-id="element-230" data-mp="v8ncpcxfipjo">
                <div className="flex items-center justify-between" data-id="element-231" data-mp="q896m0fe1poa">
                  <div className="flex gap-1" role="img" aria-label={t(ui.testimonials.rating)} data-id="element-232" data-mp="h555tosv77qr">
                    {Array.from({
                  length: 5
                }).map((_, i) => <StarIcon key={i} className="h-5 w-5 fill-gold text-gold" aria-hidden="true" data-id="element-233" data-mp="78aatfvsvph8" data-mpi={i} />)}
                  </div>
                  <QuoteIcon className="h-8 w-8 text-gold/40" aria-hidden="true" data-id="element-234" data-mp="c7deox01npnm" />
                </div>
                <blockquote className="mt-5 text-lg leading-relaxed text-white" data-id="element-235" data-mp="zx7sbgs6ti8x">“{t(item.quote)}”</blockquote>
                <figcaption className="mt-auto flex items-center justify-between gap-4 pt-7" data-id="element-236" data-mp="14xlpg3s937s6">
                  <span className="font-display font-semibold text-white" data-id="element-237" data-mp="q4jymuwi7uef">{item.author}</span>
                  <span className="inline-flex items-center gap-1.5 text-sm text-white/65" data-id="element-238" data-mp="v3wm9hv795i2">
                    <MapPinIcon className="h-4 w-4" aria-hidden="true" data-id="element-239" data-mp="1itz99jk9bl9t" />
                    {item.location}
                  </span>
                </figcaption>
              </figure>
            </li>)}
        </ul>
      </div>
    </section>;
}